import { T as fallback, S as escape_html, V as bind_props, W as ensure_array_like, X as head, P as pop, Y as attr, N as push, Z as stringify, Q as slot, _ as store_get, $ as unsubscribe_stores, a0 as spread_props } from "../../chunks/index.js";
import { A as Animate, D as DownloadButton, P as PurchaseButton, I as Icon, u as userCount, B as Button, p as page, r as release, L as Loading, N as Navbar, F as Footer } from "../../chunks/Loading.js";
import demo$1 from "../../chunks/glimmr-product-diagram.js";
import happyCustomer from "../../chunks/happy-customer.js";
import mia from "../../chunks/mia.js";
import jordan from "../../chunks/jordan.js";
import riley from "../../chunks/riley.js";
import alex from "../../chunks/alex.js";
function Detail($$payload, $$props) {
  let icon = fallback($$props["icon"], "");
  let title = fallback($$props["title"], "");
  let description = fallback($$props["description"], "");
  $$payload.out += `<div class="gap-4 flex flex-col w-full md:max-w-sm"><div class="p-4 rounded-full flex items-center justify-center bg-zinc-800 text-teal-500 self-start"><span class="material-symbols-outlined">${escape_html(icon)}</span></div> <div class="flex flex-col gap-2"><div class="text-2xl font-display font-bold">${escape_html(title)}</div> <div class="opacity-70 text-xl leading-relaxed">${escape_html(description)}</div></div></div>`;
  bind_props($$props, { icon, title, description });
}
function HeroBanner($$payload, $$props) {
  push();
  const detail = [
    {
      icon: "monitor",
      title: "Multi-Monitor Support",
      description: "Supports direct monitor adjustments for 100K+ monitors and displays."
    },
    {
      icon: "schedule",
      title: "Custom Schedules",
      description: "Set your brightness to adjust automatically, aligning with your daily workflow. Enjoy perfect lighting, from dawn till dusk."
    },
    {
      icon: "donut_small",
      title: "Shade Mode",
      description: "For old or incompatible monitors, simulate brightness adjustments with a dark, translucent overlay."
    }
  ];
  const each_array = ensure_array_like(detail);
  head($$payload, ($$payload2) => {
    $$payload2.out += `<link rel="preload" as="image"${attr("href", demo$1)}>`;
  });
  $$payload.out += `<div class="section-container bg-white text-white relative z-0 pt-12"><div class="section p-12 md:p-24 !py-36 bg-zinc-900 rounded-3xl relative z-20 bg-repeat bg-contain"><div class="section relative z-10"><div class="text-center xl:text-left grid grid-cols-1 lg:grid-cols-2 gap-12 items-center"><div class="space-y-12 z-10"><div class="space-y-8 text-shadow-2xl shadow-amber-100/10">`;
  Animate($$payload, {
    children: ($$payload2) => {
      $$payload2.out += `<div class="max-w-sm mx-auto lg:mx-0 lg:text-left text-center text-5xl md:text-6xl lg:text-7xl text-transparent font-display font-bold flex md:block justify-center"><span class="bg-clip-text bg-teal-500 capitalize leading-tight">Simplified Brightness Control</span></div>`;
    },
    $$slots: { default: true }
  });
  $$payload.out += `<!----> `;
  Animate($$payload, {
    delay: "0.1s",
    children: ($$payload2) => {
      $$payload2.out += `<div class="text-2xl md:text-4xl font-display opacity-80">Easily adjust brightness for all your displays right from your
								system tray.</div>`;
    },
    $$slots: { default: true }
  });
  $$payload.out += `<!----></div> `;
  Animate($$payload, {
    delay: "0.2s",
    className: "flex gap-4 flex-wrap items-center justify-center lg:justify-start",
    children: ($$payload2) => {
      DownloadButton($$payload2, {
        background: "dark",
        primary: true,
        size: 2,
        enableStoreDownload: true
      });
    },
    $$slots: { default: true }
  });
  $$payload.out += `<!----></div> <div class="shrink-0 -order-1 lg:order-1 flex items-center justify-center w-full h-full relative"><div class="w-full max-w-lg flex items-center justify-center">`;
  Animate($$payload, {
    children: ($$payload2) => {
      $$payload2.out += `<img${attr("src", demo$1)} class="min-w-80" alt="demo">`;
    },
    $$slots: { default: true }
  });
  $$payload.out += `<!----></div></div></div></div> <div class="section flex flex-col justify-center md:flex-row flex-wrap gap-12 mt-24"><!--[-->`;
  for (let i = 0, $$length = each_array.length; i < $$length; i++) {
    let { icon, title, description } = each_array[i];
    Detail($$payload, { icon, title, description });
  }
  $$payload.out += `<!--]--></div></div></div>`;
  pop();
}
function Features($$payload) {
  const features = [
    {
      icon: "light_mode",
      title: "Precise Brightness Control",
      description: "Effortlessly adjust display brightness individually or in sync with other displays."
    },
    {
      icon: "schedule",
      title: "Personalized Brightness Schedules",
      description: "Easily modify brightness levels based on the time of day."
    },
    {
      icon: "sync_saved_locally",
      title: "Universal Monitor Compatibility",
      description: "Unlike other brightness tools, Glimmr works with all display types, regardless of connection type."
    },
    {
      icon: "model_training",
      title: "Brightness Profiles",
      description: "Easily switch between brightness levels for different lighting scenarios with predefined modes or customize your own."
    },
    {
      icon: "sentiment_very_satisfied",
      title: "Reduced Eye Strain",
      description: "Prolonged exposure to bright screens can cause eye strain. If it's too cumbersome to adjust your monitor's brightness manually, Glimmr can help."
    },
    {
      icon: "rocket_launch",
      title: "Auto Startup",
      description: "Glimmr starts up with Windows by default and automatically applies your predefined brightness adjustments so you don't have to."
    }
  ];
  const each_array = ensure_array_like(features);
  $$payload.out += `<div class="section-container bg-teal-900/10 mt-24"><div class="section py-24"><div class="grid grid-cols-1 gap-12 items-center z-10 relative"><h1 class="text-6xl font-display text-black font-bold text-center leading-tight md:leading-tight">Designed for Simplicity</h1> <section class="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 p-2 md:p-0"><!--[-->`;
  for (let i = 0, $$length = each_array.length; i < $$length; i++) {
    let feature = each_array[i];
    $$payload.out += `<div class="w-full h-full flex items-stretch justify-stretch">`;
    Animate($$payload, {
      className: "flex-grow",
      children: ($$payload2) => {
        $$payload2.out += `<section class="p-4 md:p-12 gap-8 h-full text-left flex flex-col"><div class="flex flex-col items-center justify-center size-16 p-12 bg-white text-teal-500 rounded-3xl"><span class="material-symbols-outlined !text-5xl">${escape_html(feature.icon)}</span></div> <div class="flex flex-col gap-4"><h1 class="text-4xl font-display text-black leading-tight font-bold">${escape_html(feature.title)}</h1> <p class="text-xl opacity-80 leading-relaxed">${escape_html(feature.description)}</p></div></section>`;
      },
      $$slots: { default: true }
    });
    $$payload.out += `<!----></div>`;
  }
  $$payload.out += `<!--]--></section> <div class="mx-auto flex gap-2 flex-col md:flex-row">`;
  DownloadButton($$payload, { size: 4 });
  $$payload.out += `<!----> `;
  PurchaseButton($$payload, { size: 4 });
  $$payload.out += `<!----></div></div></div></div>`;
}
function QA($$payload, $$props) {
  let question = fallback($$props["question"], "");
  let answer = fallback($$props["answer"], "");
  $$payload.out += `<section${attr("class", `rounded-3xl flex flex-col items-center justify-center p-6 cursor-pointer transition ${stringify("bg-white text-black hover:bg-teal-900/10")}`)}><div class="flex items-center justify-between text-left w-full"><h1 class="font-medium transition max-w-2xl font-display text-xl">${escape_html(question)}</h1> <span class="material-symbols-outlined">${escape_html("expand_more")}</span></div> <div><p class="text-left pt-4 pb-2 text-xl leading-relaxed opacity-90">${escape_html(answer)}</p></div></section>`;
  bind_props($$props, { question, answer });
}
function FAQ($$payload) {
  const data = [
    {
      question: "How does it work?",
      answer: "Glimmr simplifies brightness adjustment by directly interfacing with your monitors through DDC/CI. This provides the same outcome as using the built-in buttons on the monitor's back or sides, but with enhanced convenience and ease-of-use."
    },
    {
      question: "Can I adjust the brightness of individual monitors in a multi-monitor setup?",
      answer: "Certainly! With Glimmr, you have the flexibility to adjust the brightness of individual monitors in a multi-monitor setup. The tool recognizes and allows you to control each connected monitor separately. This means you can fine-tune the brightness settings of each monitor independently, ensuring optimal visual experience and comfort across your entire multi-monitor configuration. Glimmr provides you with the granular control needed to tailor the brightness levels of each monitor to your specific preferences and requirements."
    },
    {
      question: "Can I set a global brightness level?",
      answer: "Yes, you have the ability to set a global brightness level for all your monitors simultaneously with a single slider. This means you can adjust the brightness of all connected monitors at once, ensuring a uniform and consistent brightness experience across your entire display setup. It's a convenient feature that saves you time and effort, as you don't have to adjust each monitor individually."
    },
    {
      question: "Is the app compatible with all versions of Windows?",
      answer: "Glimmr should run on all versions of Windows 7 and up, including Windows 8, 10, and 11."
    },
    {
      question: "Does the app work with monitors from different manufacturers?",
      answer: "Absolutely! Glimmr utilizes DDC/CI to directly adjust brightness, ensuring compatibility with a wide range of monitors. In case you encounter flickering or consistent brightness levels, consider trying a different connection type (preferably direct instead of using adapters or USB-C hubs). Alternatively, you can utilize Shade Mode, which works seamlessly on all monitors regardless of the connection type."
    },
    {
      question: "What is Shade Mode?",
      answer: "With a premium license, you can easily activate Shade Mode on any monitor. This feature enables you to adjust the brightness of your monitors by creating an Always-On-Top (AOT) semi-transparent window on the desired monitor. Please note that certain native Windows elements, such as the taskbar, may appear above this window when focused. Shade Mode is particularly useful if you frequently rely on adapters or USB-C hubs for monitor connections, encounter issues when adjusting brightness natively, or prefer setting your monitors to lower brightness levels than what they typically offer."
    },
    {
      question: "Can I schedule automatic brightness adjustments based on specific times of day?",
      answer: "Absolutely! The scheduling feature allows you to create a custom brightness schedule tailored to your preferences. Simply specify the target monitors, desired times, and corresponding brightness levels, and Glimmr will automatically adjust the brightness of your monitors according to the schedule you've set. This enables you to have an optimized viewing experience at different times, without the need for manual adjustments."
    },
    {
      question: "Is the app compatible with both desktop and laptop computers?",
      answer: "Yes, you can use Glimmr to adjust both internal and external monitors. It can also be used from a laptop or desktop, whichever you prefer."
    }
  ];
  const each_array = ensure_array_like(data);
  $$payload.out += `<section class="w-full bg-white border-t border-gray-100 z-0"><div class="section flex flex-col items-center py-24 gap-12 text-center"><div class="space-y-6"><h1 class="text-5xl md:text-6xl font-display font-bold">Got questions?</h1> <p class="opacity-70 text-2xl">We've got answers. Check out our frequently asked questions below.</p></div> <div class="grid grid-cols-1 lg:grid-cols-2 gap-12"><!--[-->`;
  for (let i = 0, $$length = each_array.length; i < $$length; i++) {
    let content = each_array[i];
    Animate($$payload, {
      children: ($$payload2) => {
        QA($$payload2, {
          question: content.question,
          answer: content.answer
        });
      },
      $$slots: { default: true }
    });
  }
  $$payload.out += `<!--]--></div></div></section>`;
}
function SplitScreen($$payload, $$props) {
  $$payload.out += `<div class="w-full grid grid-cols-1 lg:grid-cols-4 gap-24 items-center">`;
  Animate($$payload, {
    className: "col-span-2",
    children: ($$payload2) => {
      $$payload2.out += `<!---->`;
      slot($$payload2, $$props, "left", {});
      $$payload2.out += `<!---->`;
    },
    $$slots: { default: true }
  });
  $$payload.out += `<!----> `;
  Animate($$payload, {
    className: "col-span-2",
    children: ($$payload2) => {
      $$payload2.out += `<!---->`;
      slot($$payload2, $$props, "right", {});
      $$payload2.out += `<!---->`;
    },
    $$slots: { default: true }
  });
  $$payload.out += `<!----></div>`;
}
const demo = "/_app/immutable/assets/demo.YtskN_MP.mp4";
function Intro($$payload) {
  $$payload.out += `<section class="section-container"><div class="section p-36 rounded-3xl bg-teal-900/5 text-black">`;
  SplitScreen($$payload, {
    $$slots: {
      left: ($$payload2) => {
        $$payload2.out += `<div slot="left"><video class="w-full h-full rounded-3xl" autoplay loop muted playsinline><source${attr("src", demo)} type="video/mp4"></video></div>`;
      },
      right: ($$payload2) => {
        $$payload2.out += `<div slot="right"><div class="space-y-8 flex flex-col items-center max-w-lg mx-auto text-center">`;
        Icon($$payload2, {
          icon: "mdi:cursor-default-click",
          class: "text-6xl text-teal-500"
        });
        $$payload2.out += `<!----> `;
        Animate($$payload2, {
          children: ($$payload3) => {
            $$payload3.out += `<div class="text-teal-500 text-4xl md:text-5xl lg:text-6xl font-display leading-tight font-bold">Accessible &amp; Convenient</div>`;
          },
          $$slots: { default: true }
        });
        $$payload2.out += `<!----> `;
        Animate($$payload2, {
          children: ($$payload3) => {
            $$payload3.out += `<div class="opacity-70 font-display text-xl lg:text-2xl !leading-relaxed">No more fiddling with monitor settings or dealing with the dreaded
							Windows brightness slider. All your displays will be automatically
							detected and available for adjustment.</div>`;
          },
          $$slots: { default: true }
        });
        $$payload2.out += `<!----></div></div>`;
      }
    }
  });
  $$payload.out += `<!----></div></section>`;
}
function Testimonial($$payload, $$props) {
  let message = fallback($$props["message"], "");
  let name = fallback($$props["name"], "");
  let title = fallback($$props["title"], "");
  let avatar = $$props["avatar"];
  $$payload.out += `<div class="bg-teal-900/10 rounded-3xl p-8 flex flex-col gap-8 h-full"><div class="flex-grow"><span class="material-symbols-outlined transform rotate-180 text-left self-start opacity-70" style="font-size: 3rem !important;">format_quote</span> <div class="text-lg leading-relaxed">${escape_html(message)}</div></div> <div class="flex items-center space-x-2"><div class="rounded-full overflow-hidden"><img${attr("src", avatar)} width="48" height="48"></div> <div><div class="font-medium opacity-90">${escape_html(name)}</div> <div class="opacity-70">${escape_html(title)}</div></div></div></div>`;
  bind_props($$props, { message, name, title, avatar });
}
function Testimonials($$payload) {
  $$payload.out += `<div class="w-full bg-white"><div class="section py-36">`;
  SplitScreen($$payload, {
    $$slots: {
      left: ($$payload2) => {
        $$payload2.out += `<div slot="left"><img class="object-contain"${attr("src", happyCustomer)}></div>`;
      },
      right: ($$payload2) => {
        $$payload2.out += `<div slot="right" class="space-y-4 md:space-y-8"><div class="text-6xl font-bold font-display text-black">See What Our Customers Have to Say</div> <div class="grid grid-cols-1 xl:grid-cols-2 grid-rows-2 gap-10 gap-y-16 pt-12">`;
        Testimonial($$payload2, {
          name: "Mia T.",
          title: "Digital Marketing Manager",
          message: "Before Glimmr, adjusting my monitor's brightness was a daily hassle, especially when dealing with the tiny buttons on the back of my screen. Now, I can easily manage everything from my desktop. It's not just convenient; it's a relief.",
          avatar: mia
        });
        $$payload2.out += `<!----> `;
        Testimonial($$payload2, {
          name: "Jordan M.",
          title: "Aspiring Writer",
          message: "The custom schedules feature in Glimmr has been a game-changer for me. I love how my screen automatically dims as the sun sets, making those long writing sessions less of a strain on my eyes. It's such a smart, user-friendly tool.",
          avatar: jordan
        });
        $$payload2.out += `<!----> `;
        Testimonial($$payload2, {
          name: "Riley S.",
          title: "Graphic Designer",
          message: "I'm all about aesthetics, and Glimmr is not only a lifesaver for managing my dual monitors but it's also beautifully designed. It fits perfectly into my workflow and my desktop setup. Finally, an app that gets it right.",
          avatar: riley
        });
        $$payload2.out += `<!----> `;
        Testimonial($$payload2, {
          name: "Alex D.",
          title: "IT Professional",
          message: "Dealing with multiple monitors used to mean constantly fiddling with settings to get a uniform look. With Glimmr, it's a one-time setup, and everything is synchronized perfectly. It's such a simple solution to what was an ongoing frustration.",
          avatar: alex
        });
        $$payload2.out += `<!----></div></div>`;
      }
    }
  });
  $$payload.out += `<!----></div></div>`;
}
function TrustedBy($$payload, $$props) {
  push();
  var $$store_subs;
  $$payload.out += `<div class="section-container"><div class="section text-white bg-teal-950 rounded-3xl flex flex-col md:flex-row gap-12 items-center justify-between py-24"><h1 class="text-4xl text-center 2xl:text-left font-display font-bold">Join our growing family of <span class="text-teal-500">${escape_html(store_get($$store_subs ??= {}, "$userCount", userCount).toLocaleString())}</span> satisfied users!</h1> `;
  DownloadButton($$payload, { background: "dark", primary: false, size: 2 });
  $$payload.out += `<!----></div></div>`;
  if ($$store_subs) unsubscribe_stores($$store_subs);
  pop();
}
const brightnessModeDemo = "/_app/immutable/assets/brightness-mode-demo.CKHHBi1W.mp4";
const scheduleChangeDemo = "/_app/immutable/assets/schedule-change-demo.BNQcyrKO.mp4";
const globalChangeDemo = "/_app/immutable/assets/global-change-demo.C3nU2iTg.mp4";
function Highlight($$payload, $$props) {
  let video = $$props["video"];
  let title = $$props["title"];
  let description = $$props["description"];
  $$payload.out += `<div class="bg-white gap-4 flex flex-col"><video class="rounded-3xl" autoplay loop muted playsinline${attr("src", video)}></video> <h1 class="text-2xl font-display font-bold mt-4">${escape_html(title)}</h1> <p class="text-xl leading-relaxed opacity-70">${escape_html(description)}</p></div>`;
  bind_props($$props, { video, title, description });
}
function Highlights($$payload) {
  const features = [
    {
      video: brightnessModeDemo,
      title: "Create & Apply Custom Brightness Modes",
      description: "Whether you're working, gaming, or watching a movie, with just a few clicks, you can set the perfect brightness for your display."
    },
    {
      video: scheduleChangeDemo,
      title: "Use Custom Schedules to Automate Brightness Changes",
      description: "Create custom schedules to automatically adjust your display's brightness without lifting a finger."
    },
    {
      video: globalChangeDemo,
      title: "Adjust Monitors Individually or in Sync",
      description: "Change the brightness of all your monitors at once or adjust them individually to suit your needs."
    }
  ];
  const each_array = ensure_array_like(features);
  $$payload.out += `<div class="section-container"><div class="section !px-0 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12"><!--[-->`;
  for (let i = 0, $$length = each_array.length; i < $$length; i++) {
    let feature = each_array[i];
    Highlight($$payload, spread_props([feature]));
  }
  $$payload.out += `<!--]--></div></div>`;
}
function TrustPilotBanner($$payload, $$props) {
  push();
  var $$store_subs;
  $$payload.out += `<section class="section-container"><div class="section bg-teal-800 text-white rounded-3xl py-12"><div class="flex flex-col md:flex-row items-center justify-center gap-4"><div class="font-display text-3xl">We're on</div> <a href="https://www.trustpilot.com/review/glimmr.app"><img${attr("src", store_get($$store_subs ??= {}, "$page", page).data.trustPilotInfo.logoImageUrl)} width="140" class="inline-block text-white" alt="trustpilot logo"></a> <img${attr("src", store_get($$store_subs ??= {}, "$page", page).data.trustPilotInfo.bannerImageUrl)} class="rounded-xl overflow-hidden" width="200" alt="trustpilot rating"> <div class="font-display text-xl opacity-70">${escape_html(store_get($$store_subs ??= {}, "$page", page).data.trustPilotInfo.rating)}/5</div> `;
  Button($$payload, {
    label: "See Reviews",
    startIcon: "mdi:external-link"
  });
  $$payload.out += `<!----></div></div></section>`;
  if ($$store_subs) unsubscribe_stores($$store_subs);
  pop();
}
function _page($$payload, $$props) {
  push();
  let data = $$props["data"];
  {
    release.set(data.metadata);
    userCount.set(data.userCount);
  }
  Loading($$payload);
  $$payload.out += `<!----> <div class="fade-in bg-white svelte-15sq10t">`;
  Navbar($$payload, {});
  $$payload.out += `<!----> `;
  HeroBanner($$payload);
  $$payload.out += `<!----> `;
  TrustPilotBanner($$payload);
  $$payload.out += `<!----> `;
  Highlights($$payload);
  $$payload.out += `<!----> `;
  TrustedBy($$payload);
  $$payload.out += `<!----> `;
  Intro($$payload);
  $$payload.out += `<!----> `;
  Features($$payload);
  $$payload.out += `<!----> `;
  Testimonials($$payload);
  $$payload.out += `<!----> `;
  FAQ($$payload);
  $$payload.out += `<!----> `;
  Footer($$payload);
  $$payload.out += `<!----></div>`;
  bind_props($$props, { data });
  pop();
}
export {
  _page as default
};
